import { useMonitoringWithEnduringEventProperties } from '../../integrations/monitoring'
import { TrackingEvent } from '../../model'

type SectionName = 'Inline Payment Method' | 'Inline Address'

export const useGetShowMoreLessHandler = (sectionName: SectionName): ((isNextActionShowMore: boolean) => void) => {
  const { logEvent } = useMonitoringWithEnduringEventProperties()

  const handleShowMoreLess = (isNextActionShowMore: boolean): void => {
    logEvent(TrackingEvent.PRESSED_SUMMARY_SECTION_ACTION, {
      section: sectionName,
      action: isNextActionShowMore ? 'Show More' : 'Show Less',
    })
  }

  return handleShowMoreLess
}
